"use client";

import { MoveUp, MoveDown, ArrowUp, ArrowDown } from "lucide-react";
import { twMerge } from "tailwind-merge";

interface VerticalNavigatorProps {
  currentIndex: number;
  total: number;
  onMoveUp: () => void;
  onMoveDown: () => void;
  theme?: "dark" | "light";
  className?: string;
}

const VerticalNavigator = ({
  currentIndex,
  total,
  onMoveUp,
  onMoveDown,
  theme = "light",
  className,
}: VerticalNavigatorProps) => {
  const baseBtn =
    "p-1 rounded-full transition-colors text-gray-200";

  const enabledStyle =
    theme === "dark"
      ? "hover:bg-gray-600 text-gray-100"
      : "hover:bg-gray-100 text-gray-700";

  const disabledStyle =
    "opacity-50 cursor-not-allowed";

  return (
    <div
      className={twMerge(
        "absolute top-4 right-16 flex gap-1",
        className
      )}
    >
      <button
        className={twMerge(
          baseBtn,
          currentIndex <= 0 ? disabledStyle : enabledStyle
        )}
        onClick={onMoveUp}
        disabled={currentIndex <= 0}
        title="Previous"
      >
        <ArrowUp size={18} color="gray" />
      </button>

      <button
        className={twMerge(
          baseBtn,
          currentIndex >= total - 1 ? disabledStyle : enabledStyle
        )}
        onClick={onMoveDown}
        disabled={currentIndex >= total - 1}
        title="Next"
      >
        <ArrowDown size={18} color="gray" />
      </button>
    </div>
  );
};

export default VerticalNavigator;
